import { j as e } from "./jsx-runtime-944c88e2.js";
import { AddIcon as y } from "@chakra-ui/icons";
import { Box as i, VStack as w, Text as p, Button as v, Flex as S, Stack as $, Square as C, Skeleton as D } from "@chakra-ui/react";
import { u as I, T as o } from "./eMyAsurionProvider-5bc36307.js";
import "@tanstack/react-query";
import "react";
import "./useAccount-a03adfa5.js";
import "./myasurion-shared.mixpanel.es.js";
import "./features-979fdcf7.js";
import "./providers-29a9425c.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-7d097fe4.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "mixpanel-browser";
import "@emotion/styled";
const le = (l) => {
  const { data: c } = I(), { theme: x } = c, { colors: n } = x, {
    plan: h,
    mdn: k,
    model: W,
    imei: z,
    assetId: A,
    type: d,
    status: E,
    imageEl: s,
    showMoreDetails: j,
    detailsEl: a,
    isLoading: f,
    onAddDevice: m,
    ...g
  } = l, b = [
    { field: "mdn", label: "Mobile:", weight: 700 },
    { field: "model", label: "Model:" },
    { field: "imei", label: "IMEI:" }
  ], r = "DeviceCard";
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: f ? /* @__PURE__ */ e.jsx(D, { minW: "335px", minH: "124px", w: "full", borderRadius: "8px" }) : /* @__PURE__ */ e.jsx(
    i,
    {
      id: "myasurion-devicecard",
      borderRadius: "8px",
      minW: "335px",
      minH: "124px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "gray.300",
      p: "16px",
      w: "80%",
      ...g,
      children: d === "BYOD" ? /* @__PURE__ */ e.jsx(w, { h: "140px", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(p, { fontSize: "24px", fontWeight: "light", children: /* @__PURE__ */ e.jsx(
          o,
          {
            text: "No device added yet",
            translationKey: `${r}/noDevice`
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          v,
          {
            variant: "outline",
            leftIcon: /* @__PURE__ */ e.jsx(y, {}),
            color: n.primary,
            borderColor: n.primary,
            size: "md",
            onClick: () => {
              m && m(d);
            },
            children: /* @__PURE__ */ e.jsx(
              o,
              {
                text: "Add a device",
                translationKey: `${r}/btnAddDevice`
              }
            )
          }
        )
      ] }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsxs(S, { justify: "space-between", children: [
          /* @__PURE__ */ e.jsxs(i, { flex: 1, children: [
            /* @__PURE__ */ e.jsx(
              i,
              {
                m: "0",
                mb: "15px",
                display: "inline-block",
                width: "100%",
                children: /* @__PURE__ */ e.jsx(
                  i,
                  {
                    m: 0,
                    p: "8px",
                    bg: "brand.neutral.bright",
                    borderRadius: "2px",
                    display: "inline",
                    children: /* @__PURE__ */ e.jsx(p, { fontSize: "sm", display: "inline-block", children: h })
                  }
                )
              }
            ),
            b.map((t, u) => /* @__PURE__ */ e.jsxs(
              $,
              {
                direction: "row",
                gap: 0,
                spacing: 0,
                w: "full",
                fontSize: "md",
                fontWeight: 400,
                children: [
                  /* @__PURE__ */ e.jsx(i, { w: "30%", float: "left", children: /* @__PURE__ */ e.jsx(
                    o,
                    {
                      text: t.label,
                      translationKey: `${r}/${t.field}`
                    }
                  ) }),
                  /* @__PURE__ */ e.jsx(
                    i,
                    {
                      w: "70%",
                      float: "right",
                      fontWeight: t.weight || 400,
                      children: l[`${t.field}`]
                    }
                  )
                ]
              },
              `devicecard-field-${t.field}-${u}`
            ))
          ] }),
          /* @__PURE__ */ e.jsx(C, { children: s || /* @__PURE__ */ e.jsx(i, { m: "30% auto", fontSize: "xs", color: "gray.300", children: /* @__PURE__ */ e.jsx(
            o,
            {
              text: "No image",
              translationKey: `${r}/lblNoImage`
            }
          ) }) })
        ] }),
        j && a && /* @__PURE__ */ e.jsx(i, { w: "full", children: a })
      ] })
    }
  ) });
};
export {
  le as DeviceCard
};
